import ApiService from './api.service.js'
import { generateTimestamp } from '@/utils/helper'

const attestationService = {
  getAttestationStatus: async function (accounts, callback) {
    try {
      console.log('accounts:', accounts)
      let accountIds = accounts.map(account => account.Acct_ID)
      let attestationReqBody = {
        params: {
          action: 'attestation-request-status',
          account_ids: JSON.stringify(accountIds)
        }
      }
      let attestationRes = await ApiService.get(process.env.VUE_APP_ATTESTATION_API, attestationReqBody)
      if (attestationRes.data && attestationRes.data.hasOwnProperty('result')) {
        callback(null, attestationRes.data.result)
      }
    } catch (error) {
      // callback(error)
    }
  },

  getAttestationRequest: async function (id, callback) {
    try {
      let params = { action: 'attestation-list' }
      if (id) {
        params = {
          ...params,
          Acct_ID: id,
          action: 'attestation-request-detail'
        }
      }
      let attestationReqBody = {
        params: {
          ...params,
          orderBy: 'Attestation_Id',
          order: 'DESC',
          size: 10,
          filters: { Status: 'Pending' }
        }
      }
      let attestationRes = await ApiService.get(process.env.VUE_APP_ATTESTATION_API, attestationReqBody)
      console.log('attestation response', attestationRes)
      if (attestationRes.data && attestationRes.data.hasOwnProperty('result') && attestationRes.data.result) {
        callback(null, attestationRes.data.result)
      } else {
        callback(attestationRes.data ? attestationRes.data.error : 'Unknown error', null)
      }
    } catch (error) {
      console.log(error)
      callback(error)
    }
  },

  getAccountAttestationDetail: async function (id, callback) {
    try {
      let params = { action: 'masterpayer-request' }
      if (id) {
        params = {
          ...params,
          Acct_ID: id,
          action: 'attestation-request-detail'
        }
      }
      let masterpayerRequestBody = {
        params: {
          ...params
        }
      }
      let mpResponse = await ApiService.get(process.env.VUE_APP_ATTESTATION_API, masterpayerRequestBody)
      if (mpResponse.data && mpResponse.data.hasOwnProperty('result') && mpResponse.data.result) {
        callback(null, mpResponse.data.result)
      } else {
        callback(mpResponse.data ? mpResponse.data.error : 'Unknown error', null)
      }
    } catch (error) {
      console.log(error)
      callback(error)
    }
  },

  // Upload to s3
  uploadToS3: async function (file, type) {
    if (type === 'AWS_ONBOARDING') {
      let timestamp = Math.floor(Date.now() / 1000)
      file.filename = timestamp + '_' + file.filename.replace(/\s/g, '-')
    } else {
      file.filename = file.filename.replace(/\s/g, '-')
    }
    let objectKey = file.filename
    let ContentType = file.FileType
    let requestParams = {
      params: {
        name: objectKey, method: 'put_object', contenttype: ContentType
      }
    }
    let getPresignedUrl = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, requestParams)
    let presignedUrl = getPresignedUrl.data
    let uploadDetails = { Key: file.filename, ContentType: ContentType, file: file.File }
    let uploadResponse = await ApiService.put(presignedUrl, uploadDetails)
    return uploadResponse
  },

  downloadDocument: async function (key, callback) {
    try {
      let requestParams = {
        params: {
          name: key, method: 'get_object'
        }
      }
      let getPresignedUrl = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, requestParams)
      let presignedUrl = getPresignedUrl.data
      callback(null, presignedUrl)
    } catch (error) {
      console.log(error)
      callback(error, null)
    }
  },

  attestationSubmit: async function (data, callback) {
    try {
      // check if files exist
      if (data.files && data.files.length) {
        // Prepare the file data
        const fileData = Array.from(data.files).map(file => ({
          name: 'Attestation_' + generateTimestamp() + '_' + file.name,
          type: file.type
        }))
        let requestParams = {
          params: {
            files: JSON.stringify(fileData), method: 'put_object', is_multiple_upload: true
          }
        }
        let getPresignedUrl = await ApiService.get(process.env.VUE_APP_GALAXY_UPLOAD, requestParams)
        let presignedUrls = getPresignedUrl.data
        if (presignedUrls) {
          await Promise.all(fileData.map((file, index) => {
            let uploadDetails = { Key: file.name, ContentType: file.type, file: data.files[index] }
            return ApiService.put(presignedUrls[index], uploadDetails)
          }))
          data['Architecture_Diagram'] = fileData.map(file => file.name).join(',')
          delete data.files
        }
      }
      console.log('data to upload', data)
      let submitAttestationBody = {
        action: 'submit-attestation',
        ...data
      }
      console.log(submitAttestationBody)
      let attestationResponse = await ApiService.post(process.env.VUE_APP_ATTESTATION_API, submitAttestationBody)
      console.log(attestationResponse)
      if (attestationResponse.data && attestationResponse.data.result > 0) {
        callback(null, attestationResponse.data.result)
      } else {
        callback('An Error has occured.', null)
      }
    } catch (error) {
      console.log(error)
      callback(error, null)
    }
  },

  updateAttestation: async function (data, callback) {
    try {
      let updateAttestationBody = {
        action: 'update-attestation',
        Status: data['Status'],
        Acct_ID: data['Acct_ID']
      }
      let attestationResponse = await ApiService.post(process.env.VUE_APP_ATTESTATION_API, updateAttestationBody)
      console.log(attestationResponse)
      if (attestationResponse.data && attestationResponse.data.result) {
        callback(null, attestationResponse.data.result)
      } else {
        callback('An Error has occured.', null)
      }
    } catch (error) {
      console.log('ERROR', error)
      callback(error, null)
    }
  }
}

export default attestationService
